import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  creditNotes: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const creditNoteSlice = createSlice({
  name: "creditNote",
  initialState,
  reducers: {
    fetchCreditNotesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCreditNotesSuccess(state, action) {
      state.creditNotes = action.payload.creditNotes;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchCreditNotesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addCreditNoteStart(state) {
      state.loading = true;
      state.error = null;
    },
    addCreditNoteSuccess(state, action) {
      state.loading = false;
      state.creditNotes.unshift(action.payload);
      state.error = null;
    },
    addCreditNoteFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteCreditNoteStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteCreditNoteSuccess(state, action) {
      state.loading = false;
      state.creditNotes = state.creditNotes.filter(
        (creditNote) => creditNote.id !== action.payload,
      );
      state.error = null;
    },
    deleteCreditNoteFailure(state, action) {
      state.loading = false; // fixed: was `true` in original customer slice
      state.error = action.payload;
    },

    editCreditNoteStart(state) {
      state.loading = true;
      state.error = null;
    },
    editCreditNoteSuccess(state, action) {
      state.loading = false;
      const updatedCreditNote = action.payload;
      const index = state.creditNotes.findIndex(
        (creditNote) => creditNote.id === updatedCreditNote.id,
      );
      if (index !== -1) {
        state.creditNotes[index] = updatedCreditNote;
      }
      state.error = null;
    },
    editCreditNoteFailure(state, action) {
      state.loading = false; // fixed: was `true` in original customer slice
      state.error = action.payload;
    },

    fetchCreditNotePDFStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCreditNotePDFSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    fetchCreditNotePDFFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // add to reducers: {}
    getCreditNoteByIdStart(state) {
      state.loading = true;
      state.error = null;
      state.selectedCreditNote = null;
    },
    getCreditNoteByIdSuccess(state, action) {
      state.loading = false;
      state.selectedCreditNote = action.payload;
      state.error = null;
    },
    getCreditNoteByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    resetCreditNotes(state) {
      state.creditNotes = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchCreditNotesStart,
  fetchCreditNotesSuccess,
  fetchCreditNotesFailure,

  addCreditNoteStart,
  addCreditNoteSuccess,
  addCreditNoteFailure,

  deleteCreditNoteStart,
  deleteCreditNoteSuccess,
  deleteCreditNoteFailure,

  editCreditNoteStart,
  editCreditNoteSuccess,
  editCreditNoteFailure,

  fetchCreditNotePDFStart,
  fetchCreditNotePDFSuccess,
  fetchCreditNotePDFFailure,

  getCreditNoteByIdStart,
  getCreditNoteByIdSuccess,
  getCreditNoteByIdFailure,

  resetCreditNotes,
} = creditNoteSlice.actions;

export default creditNoteSlice.reducer;
